var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEasxLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50.6 73.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Unbenannter_Verlauf_8);}.cls-2{fill:url(#Unbenannter_Verlauf_8-2);}.cls-3{fill:url(#Unbenannter_Verlauf_5);}.cls-4{fill:url(#Unbenannter_Verlauf_8-3);}.cls-5{fill:#353a8d;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_8",
    x1: 492.86,
    y1: 1598.22,
    x2: 454.41,
    y2: 1597.69,
    gradientTransform: "translate(-443.89 -1560.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#d0d1e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#acadcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#8c8ebc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#7073ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#5a5ea2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#494d99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#3e4193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#373b8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35398e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_8-2",
    x1: 467.95,
    y1: -1696.1,
    x2: 452.95,
    y2: -1696.01,
    gradientTransform: "translate(1722.48 465.68) rotate(-90)",
    xlinkHref: "#Unbenannter_Verlauf_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_5",
    x1: 1281.76,
    y1: -2177.48,
    x2: 1243.3,
    y2: -2177.48,
    gradientTransform: "translate(-1253.08 2214.41)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#fafafc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#d1d2e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#acaed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#8c8ebe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#7073af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#5a5ea3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#494d99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#3e4193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#373b8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35398e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_8-3",
    x1: -471.04,
    y1: 1859.48,
    x2: -456.04,
    y2: 1859.48,
    gradientTransform: "translate(-1851.98 -396.19) rotate(-90)",
    xlinkHref: "#Unbenannter_Verlauf_8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.21,
    y: 29.44,
    width: 38.46,
    height: 15,
    rx: 7.5,
    transform: "translate(63.38 10.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 26.44,
    cy: 7.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -11.73,
    y: 29.43,
    width: 38.46,
    height: 15,
    rx: 7.5,
    transform: "translate(-29.43 44.43) rotate(-90)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 7.5,
    cy: 66.37,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M39.78,10.07V0h8.93V2.55H42.6v1.2h5.88V6.27H42.6V7.53h6.11v2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.88,25.35l4.34-10h4L50.6,25.35H47.36l-.76-1.86H41.83l-.78,1.86Zm5-4.4h2.67L45,19.54l-.66-1.69h-.2l-.64,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38.09,56.16,41.89,51v-.2l-3.8-5.17h3.69L44.21,49h.2L46.7,45.6h3.69l-3.78,5.23V51l3.78,5.12H46.7l-2.41-3.44h-.2l-2.31,3.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M44.41,29.6c2.92,0,4.9,1.23,4.9,3.6v.45H46V33.2c0-.64-.56-1.06-1.64-1.06h-.22c-1.1,0-1.66.35-1.66.76v.2c0,.59.45.83,2.86,1.34,2.85.67,4.12,1.67,4.12,3.58v.17c0,1.93-1.62,3.41-5.06,3.41h-.28c-3.43,0-5.15-1.51-5.15-3.88v-.38h3.29v.4c0,1,.69,1.31,1.89,1.31h.23c1.13,0,1.77-.3,1.77-.82v-.12c0-.54-.64-.87-3.14-1.41s-3.85-1.55-3.85-3.41V33c0-2.19,1.86-3.41,4.94-3.41Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasxLogoLight);
export default __webpack_public_path__ + "static/media/EASX_Logo_Light.a7eb58958e3da90491af5319eab92301.svg";
export { ForwardRef as ReactComponent };